import * as amplitude from '@amplitude/analytics-browser';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { storageHelper } from '@spo/logic';
import { initI18n } from '@spo/services/i18n';
import { App } from './components';
import { GTMContainer } from './components/containers/gtm';
import { Loading } from './components/loading';
import { RolesProvider } from './contexts/RolesContext';
import { ToastProvider } from './contexts/ToastContext';
import { environment } from './environments/environment';
import './styles.css';

const bootstrap = async () => {
  const defaultLanguage = 'en-GB';
  await initI18n(defaultLanguage);

  if (environment.amplitudeApiKey) {
    amplitude.init(environment.amplitudeApiKey, {
      serverZone: 'EU',
      autocapture: {
        pageViews: false,
        sessions: true,
        frustrationInteractions: true,
      },
    });
    window.amplitude = amplitude;
  }

  if (!storageHelper.getItem('theme')) storageHelper.setItem('theme', 'light');

  const container = document.getElementById('root');

  if (container) {
    const root = ReactDOM.createRoot(container);
    const queryClient = new QueryClient();
    root.render(
      <React.StrictMode>
        <Suspense fallback={<Loading />}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <GTMContainer gtmId={environment.gtmId}>
                <RolesProvider>
                  <ToastProvider>
                    <App />
                  </ToastProvider>
                </RolesProvider>
              </GTMContainer>
            </BrowserRouter>
            {!environment.test && (
              <ReactQueryDevtools
                initialIsOpen={false}
                buttonPosition="bottom-left"
              />
            )}
          </QueryClientProvider>
        </Suspense>
      </React.StrictMode>,
    );
  }
};

if (['msw_mocked'].includes(environment.env)) {
  import('../../../__mocks__/browser')
    .then(({ worker }) => worker.start({ onUnhandledRequest: 'bypass' }))
    .then(bootstrap)
    .catch((error) => console.error(error));
} else {
  bootstrap().catch((error) => console.error(error));
}
